import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  IbanAccountAddCommand,
  IbanAccountApi,
  IbanAccountResponseDto,
  IbanAccountUpdateCommand,
} from "api";

const ibanAccountApi = new IbanAccountApi();

export interface IbanAccount extends IbanAccountResponseDto {
  id: string;
}

export type EditableIbanAccount = Omit<IbanAccount, "ibanAccountUid"> & {
  ibanAccountUid: string | null;
};

export interface IbanAccountState {
  accounts: IbanAccount[] | null;
  // Uncomment if pagination is needed

  // pageCount: number;
  // pageNumber: number;
  // pageSize: number;
  totalCount: number;
}

const initialState: IbanAccountState = {
  accounts: null,
  totalCount: 0,
  // pageCount: 0,
  // pageNumber: 1,
  // pageSize: 5,
};

export const getIbanAccounts = createAsyncThunk<IbanAccountResponseDto[]>(
  "ibanAccount/getAll",
  async () => {
    const { data } = await ibanAccountApi.apiIbanAccountGet();
    return data;
  }
);

export const getIbanAccountByUid = createAsyncThunk<
  IbanAccountResponseDto,
  string
>("ibanAccount/getByUid", async (uid: string) => {
  const { data } = await ibanAccountApi.apiIbanAccountIbanAccountUidGet(uid);
  return data;
});

export const createIbanAccount = createAsyncThunk<
  IbanAccountResponseDto,
  {
    body: IbanAccountAddCommand;
  }
>("ibanAccount/create", async ({ body }) => {
  const { data } = await ibanAccountApi.apiIbanAccountPost(body);
  return data;
});

export const updateIbanAccountByUid = createAsyncThunk<
  IbanAccountResponseDto,
  {
    body: IbanAccountUpdateCommand;
  }
>("ibanAccount/update", async ({ body }) => {
  const { data } = await ibanAccountApi.apiIbanAccountPut(body);
  return data;
});

export const deleteIbanAccountByUid = createAsyncThunk<void, string>(
  "ibanAccount/delete",
  async (uid: string) => {
    await ibanAccountApi.apiIbanAccountIbanAccountUidDelete(uid);
  }
);

const ibanAccountSlice = createSlice({
  name: "ibanAccount",
  initialState,
  reducers: {
    // setPageNumber: (state, action) => {
    //   state.pageNumber = action.payload;
    // },
    // setPageSize: (state, action) => {
    //   state.pageSize = action.payload;
    //   state.pageCount = Math.ceil(state.totalCount / action.payload);
    //   state.pageNumber = 1;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(getIbanAccounts.fulfilled, (state, action) => {
      state.accounts = action.payload.map((account) => ({
        ...account,
        id: account.ibanAccountUid,
      }));
      state.totalCount = action.payload.length;
      // state.pageCount = Math.ceil(action.payload.length / state.pageSize);

      // if (state.pageNumber > state.pageCount) {
      //   state.pageNumber = state.pageCount;
      // }
    });
  },
});

// export const { setPageNumber, setPageSize } = ibanAccountSlice.actions;
export default ibanAccountSlice.reducer;
